document.addEventListener("keydown", (event) => {
  if (event.defaultPrevented || event.isComposing) return;
  if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "k") {
    const search = document.querySelector<HTMLInputElement>("#global-patient-search");
    if (!search || document.querySelector("dialog[open]")) return;
    event.preventDefault();
    document.querySelector<HTMLDialogElement>("#patient-search-modal")?.showModal();
    search.focus();
    search.select();
  }
  const editing = event.target instanceof Element && event.target.closest("input,textarea,select,[contenteditable='true']");
  if (!editing && !document.querySelector("dialog[open]") && event.altKey && event.shiftKey && event.code === "KeyV") {
    event.preventDefault();
    window.location.assign("/clinical-hours?tab=visits&run=1&action=log-visit");
  }
});

function openRequestedVisit() {
  const params = new URLSearchParams(window.location.search);
  if (params.get("action") === "add-patient") {
    const patientDialog = document.querySelector<HTMLDialogElement>("#add-patient-modal");
    if (patientDialog && !patientDialog.open) { patientDialog.showModal(); patientDialog.querySelector<HTMLInputElement>("input")?.focus(); }
    return;
  }
  if (params.get("action") !== "log-visit") return;
  const dialog = document.querySelector<HTMLDialogElement>("#add-visit-modal");
  if (!dialog || dialog.open) return;
  const patient = dialog.querySelector<HTMLSelectElement>("[data-visit-patient]");
  if (patient && params.get("patientId")) {
    patient.value = params.get("patientId")!;
    patient.dispatchEvent(new Event("change", { bubbles: true }));
  }
  dialog.showModal();
  dialog.querySelector<HTMLElement>("select,input")?.focus();
}
window.addEventListener("DOMContentLoaded", openRequestedVisit);
document.addEventListener("htmx:afterSwap", openRequestedVisit);
